import {useMemo, useCallback} from 'react';

import {usePaymentMethod} from 'commerceAPI/hooks';
import useGooglePayWorldpay from './useGooglePayWorldpay';
import useGooglePayDefault from './useGooglePayDefault';
import {useBasket} from 'brandHooks';

/**
 * useGooglePay custom hook.
 */
const useGooglePay = () => {
	const paymentMethod = usePaymentMethod('apmgw_GooglePay');
	const configuration = paymentMethod ? paymentMethod.getPublicConfigurations() : null;
	const googlePayHandlerName = useMemo(() => {
		if (paymentMethod) {
			switch (paymentMethod.getPaymentProcessorID()) {
				case 'WORLDPAY':
					return 'WORLDPAY';
				default:
					return 'DEFAULT';
			}
		}

		return '';
	}, [paymentMethod]);
	const googlePayHandlers = {
		WORLDPAY: useGooglePayWorldpay(googlePayHandlerName === 'WORLDPAY', configuration),
		DEFAULT: useGooglePayDefault()
	};
	const googlePayHandler = googlePayHandlers[googlePayHandlerName] || googlePayHandlers.DEFAULT;

	const basket = useBasket();
	const handlePayment = useCallback((productId, handleClickCallback = null) => {
		googlePayHandler.handle(productId, handleClickCallback, basket.basketId);
	}, [googlePayHandler]);

	const getButton = useCallback((onClick, googlePayButtonStyleConfig) => {
		return googlePayHandler.getButton(onClick, googlePayButtonStyleConfig);
	}, [googlePayHandler]);

	return {
		loaded: googlePayHandler.loaded,
		loading: googlePayHandler.loading,
		handle: handlePayment,
		getButton: getButton,
		expressButtons: paymentMethod.getExpressButtons(),
	};
};

export default useGooglePay;
